import { defineMessages } from 'react-intl';
export const measureMessages = defineMessages({
    measureLine: {
        id: 'mesure.line',
        defaultMessage: 'Měřit vzdálenost',
    },
    measurePolygon: {
        id: 'mesure.polygon',
        defaultMessage: 'Měřit plochu',
    },
    measureDeleteAll: {
        id: 'mesure.deleteAll',
        defaultMessage: 'Smazat vše',
    },
    measureDelete: {
        id: 'mesure.delete',
        defaultMessage: 'Smazat',
    },
    measureArea: {
        id: 'measure.area',
        defaultMessage: 'Plocha',
    },
    measureLength: {
        id: 'measure.length',
        defaultMessage: 'Délka',
    },
});
//# sourceMappingURL=measureMessages.js.map